import React, { Component } from 'react';
import { getModels } from "../../api/apiRequests";
import { ModelsContext } from "./contexts/ModelsContext";

function modelsProvWrapper(WhatComponentNeedsWrapper) {
  const wrapper = class extends Component {

    state = { models: undefined };

    componentDidMount() {
      getModels()
      .then(res => {
        this.setState({ models: res.data })
      })
      .catch(() => {
        this.setState({ models: null });
      })
    }

    refreshModels = () => {
      getModels()
      .then(res => {
        this.setState({ models: res.data })
      })
      .catch(() => {
        alert("¡Ups!, estamos teniendo dificultades con el servidor. Espere un instante y recargue la página")
      })
    };


    render() {
      const { models } = this.state;
      return (
        <ModelsContext.Provider value={{ models, refreshModels: this.refreshModels }}>
          <WhatComponentNeedsWrapper models={models} {...this.props}/>
        </ModelsContext.Provider>
      );
    }
  };

  wrapper.displayName = ((WhatComponentNeedsWrapper.displayName || WhatComponentNeedsWrapper.name) + " < modelsProvWrapper");
  return wrapper;
}

export { modelsProvWrapper };
